export const formatMeasurementUnit = (unit: string) =>
  /^m\^?3$/.test(unit) ? "m³" : unit;
